import React from "react";
import {
  formatRelativeTime,
  formatUserDisplay,
  getLastNotification,
} from "../../Dashboard/constants/labels";
import styles from "../styles/campaignNotifications.module.scss";
import SendStatusBadge from "./SendStatusBadge";

export default function CampaignUserRow({
  user,
  index,
  audience,
  selected,
  onToggle,
}) {
  const display = formatUserDisplay(user, index);
  const send = user.send || {};
  const lastNotification = getLastNotification(user);
  const selectable = audience === "eligible" || audience === "all";

  return (
    <tr>
      {selectable ? (
        <td className={styles.checkboxCell}>
          <input
            type="checkbox"
            checked={selected}
            disabled={!user.slug}
            onChange={() => user.slug && onToggle(user.slug)}
            aria-label={`Select ${display.title}`}
          />
        </td>
      ) : null}
      <td className={styles.userHeading}>
        <div className={styles.userCell}>
          <span className={styles.userName}>{display.title}</span>
          {display.subtitle ? (
            <span className={styles.userMeta}>{display.subtitle}</span>
          ) : null}
        </div>
      </td>
      {selectable ? (
        <td className={`${styles.centerCell} ${styles.metaCol}`}>
          {lastNotification?.status ? (
            <SendStatusBadge status={lastNotification.status} />
          ) : (
            "—"
          )}
        </td>
      ) : (
        <td className={`${styles.centerCell} ${styles.metaCol}`}>
          <SendStatusBadge status={send.status} />
        </td>
      )}
      <td className={`${styles.centerCell} ${styles.dateCol}`}>
        {selectable
          ? formatRelativeTime(
              lastNotification?.sent_at || lastNotification?.created_at
            )
          : formatRelativeTime(send.sent_at)}
      </td>
      <td className={`${styles.centerCell} ${styles.dateCol}`}>
        {formatRelativeTime(user.last_active_at)}
      </td>
    </tr>
  );
}
